'use client';
import styled from 'styled-components';

export const LoginContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin: ${({ theme }) => theme.spacing(14, 6)};
`;

export const LoginFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
  max-width: 650px;
  padding: ${({ theme }) => theme.spacing(0, 6)};
  border-radius: 35px;
  margin-bottom: ${({ theme }) => theme.spacing(8)};
  background-color: ${({ theme }) => theme.colors.background.lightest};
  padding-bottom: ${({ theme }) => theme.spacing(4)};
`;

export const HeadingContainer = styled.div`
  text-align: center;
  margin-bottom: ${({ theme }) => theme.spacing(8)};
  margin-top: ${({ theme }) => theme.spacing(13)};
`;

export const SubHeading = styled.div`
  margin-top: ${({ theme }) => theme.spacing(2)};
  text-align: center;
`;

export const Form = styled.form`
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 100%;
  max-width: 512px;

  > div {
    width: inherit;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-bottom: ${({ theme }) => theme.spacing(12)};
  max-width: 336px;
`;

export const InputContainer = styled.div`
  padding-bottom: 24px;
`;

export const LinkContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacing(6)};

  a {
    color: ${({ theme }) => theme.colors.secondary.chia};
  }
`;

export const ShopifyCallout = styled.div`
  text-align: center;
  margin-top: ${({ theme }) => theme.spacing(6)};
`;

export const CanineCareCallout = styled.div`
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-bottom: ${({ theme }) => theme.spacing(8)};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 157.143% */
  letter-spacing: 0.14px;

  a {
    font-size: 14px;
    text-decoration: underline;
    color: ${({ theme }) => theme.colors.text.secondary};
  }
`;
